/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_DeleteInputs */

const vi_care_log_delete = /** @type {(inputs: Care_Log_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa nhật ký`)
};

/**

* @param {Care_Log_DeleteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_delete = /** @type {((inputs?: Care_Log_DeleteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_DeleteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_delete(inputs)
});